import {Injectable} from '@angular/core';
import { HttpClient, HttpEvent, HttpEventType, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import {map} from 'rxjs';


@Injectable({
  providedIn: 'root'
})

export class  MultiFileUploadService {

  private baseURI = '/tmssserver/api/file';
  constructor(private http: HttpClient) {}

  postMultiFile(file: File): Observable<any> {
    // console.log('File Name: ' + file.name);
    const endpoint = 'tmssserver/api/public/file';
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    // formData.append('processName', processName);

    const req = new HttpRequest('POST', this.baseURI + '/sendemails', formData, {
      reportProgress: true,
      responseType: 'text',
    });

    return this.http.request(req).pipe(
      map(event => this.getMultiEventMessage(event, file)),
    );
  }

  /** Return distinct message for sent, upload progress, & response events */
  private getMultiEventMessage(event: HttpEvent<any>, file: File) {
    console.log(event);
    switch (event.type) {
      case HttpEventType.Sent:
        return {status: 'uploading', message: 0};
      case HttpEventType.UploadProgress:
        const percentDone = Math.round(100 * event.loaded / event.total);
        return {status: 'uploading', message: percentDone};
      case HttpEventType.Response:
        return {
          status: 'done',
          // message: file.name + ' has been successfully uploaded. You will be notified via email once it has been processed and validated.'
          message: event.body
        };
      default:
        return {status: 'uploading', message: 100};
    }
  }
}
